//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_webMercatorMaxLatitude = 1.4844222297453324;\n\
";
